import NavBar from '../components/navbar/navBar';
import AchievementSection from '../components/achivementsSection';
import Footer from '../components/footer';

const AchievementsPage = () => {
    return (
        <>
            <NavBar/>
            <AchievementSection homePage='true' achievementsPage='true'/>
            <Footer/>
        </>
    );
}

export default AchievementsPage;
